// extracted by mini-css-extract-plugin
export default {"footer":"SiteFooter_footer__zFKnG","footerContact":"SiteFooter_footerContact__rdsra"};